import React from 'react';

import HorizontalBarChart from 'components/common/horizontalBarChart/HorizontalBarChart';

import { transformTopEngagedChartsData } from 'utils/chartUtils';

import { EngagementPoint } from 'types/chartTypes';

interface EngagementChartsProps {
  data: {
    pages: EngagementPoint[];
    keywords: EngagementPoint[];
  };
}

const TopEngagedPagesKeywordsCharts = ({ data }: EngagementChartsProps) => {
  const pagesData = transformTopEngagedChartsData(data.pages);
  const keywordsData = transformTopEngagedChartsData(data.keywords);

  return (
    <div className={'engagement-charts-container'}>
      <HorizontalBarChart
        data={pagesData}
        xAxisLabel='Pages'
        yAxisLabel='Engagement Minutes'
        title='Top Engaged Pages'
      />

      <HorizontalBarChart
        data={keywordsData}
        xAxisLabel='Keywords'
        yAxisLabel='Engagement Minutes'
        title='Top Engaged Keywords'
      />
    </div>
  );
};
export default TopEngagedPagesKeywordsCharts;
